import i18n from '@i18next/i18n';
import CommonTips, { CommonTipsType } from '@src/framework/frame/components/common-tips';
import { RightSideBarModule } from '../../right-side-bar-service/core/right-side-bar-module';
import { HISTORY_MODULE_NAME, NOHISTORY_HEATCODE, RecordTypeKey } from '@src/slide/application/service/history-manager/core/constants';
import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';

export default class HistoryRSBarModule extends RightSideBarModule {
    public constructor(private historyManager: IHistoryManager) {
        super();
    }

    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    public get name() {
        return HISTORY_MODULE_NAME;
    }

    public async show() {
        let shouldShowModule = false;

        if (this.historyManager.recordType === RecordTypeKey.HISTORY_VERSION) {
            shouldShowModule = true;
        } else {
            const showHistory = await this.showHistoryList();
            shouldShowModule = !!showHistory;
        }

        if (shouldShowModule) {
            this.historyManager.showModule(this.DOMNode as Element, () => {
                this.showWrapper();
            }, () => {
                this.hideWrapper();
            });
        }
    }

    public async showHistoryList() {
        const { globalPadId = '' } = SlideDataServices.DocInfoManager() ?? {};
        const apiService = await OnlineEditServices.OnlineApiService.promise();
        const res = await apiService.getHistory(globalPadId, 1).then((response) => {
            const res = response.data;
            if (res.retcode === NOHISTORY_HEATCODE) {
                const commonTipsConfig = {
                    message: i18n.t('在线人数较多，暂时无法查看修订记录'),
                    commonTipsType: CommonTipsType.INFO,
                    block: false,
                    closable: true,
                };
                CommonTips.getInstance().show(commonTipsConfig);
                return false;
            }
            return true;
        });
        return res;
    }

    public wrapperDidHide() {
        this.historyManager.hideModule(this.DOMNode as Element);
    }
}
